export const DEFAULT_PROPOSAL_THEME = {
	primaryColor: "#6366f1",
	secondaryColor: "#a855f7",
	fontFamily: "Inter",
	borderRadius: "12",
};

export const DEFAULT_PROPOSAL_VARIABLES = {
	client_name: "",
	proposal_id: "PROP-GENERATING",
	total_value: "R$ 0,00",
};

export const DEFAULT_ACCEPTANCE_CONFIG = {
	show_acceptance: true,
	require_role: false,
	require_phone: false,
	legal_text:
		"Ao assinar, o cliente concorda com os termos e condicoes descritos nesta proposta comercial.",
};

export const PREVIEW_VARIABLES = {
	client_name: "NERD WORKING",
	proposal_id: "PROP-2024-NW",
	total_value: "R$ 1.380,00",
};

export const INITIAL_PROPOSAL_FORM_DATA = {
	client_id: "",
	company_id: "",
	title: "",
	description: "",
	notes: "",
	validity_days: 30,
	template_id: "",
	theme: { ...DEFAULT_PROPOSAL_THEME },
	variables: { ...DEFAULT_PROPOSAL_VARIABLES },
	acceptance_config: { ...DEFAULT_ACCEPTANCE_CONFIG },
};
